import(/* webpackMode: "eager" */ "/var/www/kst-frontend-staging/app/terms-of-Use/page.tsx")